

    export class BackgroundContainer extends Phaser.Group {

        constructor(game: Phaser.Game) {

            super(game, null, "background-container");

            const road = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "background.png");
            this.add(road);
        }
    }
